import { createSvgComponent } from "../../icon/createSvgComponent";
import HomeHeartFill from "@core/icon/assets/home-heart-fill.svg";
export default createSvgComponent(HomeHeartFill);